// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : help package
// =============================================================================
export const templates = true;
export const parts = true;
import * as reducers from './reducers';
export { reducers };
import * as actions from './actions';
export { actions };
